import React from 'react';
import Logo from '../../Logo/logo';
import { ICompanyResponse } from '../../../../../../Interfaces/responseTypes';
import CustomDrawer from '../../../../../../Components/Drawer/CustomDrawer/customDrawer';
import { useDrawerHooks } from '../../../../../../Components/Drawer/drawer-hooks';
import RestaurantDrawer from '../../Drawer/Main/restaurantDrawer';
import { useGeneralHooks } from '../../../../../../Hooks/hooks';
import { Menu } from '../../../../../../Assets/Icons';
import styles from './mainHeaderStandart.module.scss';

interface IProps {
  data: ICompanyResponse,
  onCompanyUpdate: () => void,
}

const MainHeaderStandart: React.FC<IProps> = (props) => {
  const { data, onCompanyUpdate } = props;
  const { openDrawer, onCloseDrawer, onOpenDrawer } = useDrawerHooks();
  const { baseURL, navigate } = useGeneralHooks();

  return (
    <div className={styles.header}>
      <Logo imageUrl={data.logo} baseURL={baseURL!} onClick={() => navigate(`/my_business/${data.id!}`)} />
      <p className={styles.title}>{data.name}</p>
      <img src={Menu} alt='menuIcon' onClick={onOpenDrawer} className={styles.menuIcon} />
      <CustomDrawer
        children={
          <RestaurantDrawer
            data={data}
            onCompanyUpdate={onCompanyUpdate}
          />
        }
        open={openDrawer}
        onClose={onCloseDrawer}
      />
    </div>
  )
}

export default MainHeaderStandart
